import routes from '@routes/config';

export default [{
    path: routes.setting.index,
    name: routes.setting.index,
    component: () => import(/* webpackChunkName: "Setting" */  '@components/Setting/Index')
}]
            